module.exports = __webpack_public_path__ + "static/GalanoGrotesque-Light-3883e0c77a1b7f171bc96244c0b416ed.woff2";